<ng-container [formGroup]="form">
  <select name="{{ replacement.asString }}" formControlName="{{ replacement.asString }}">
    <option *ngFor="let option of replacement.answerOptions" value="{{ option.id }}">{{ option.text }}</option>
  </select>
</ng-container>
